import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0, .5)',
        zIndex: 1,
    },
    content: {
        border: '1px solid #000',
        padding: theme.spacing(1.4),
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
        maxWidth: '100%',
        boxSizing: 'border-box',
        textAlign: 'center',
    },
    typography: {
        fontSize: '1.4rem',
        fontWeight: 500,
        color: theme.palette.text.primary,
        margin: 0,
    }
}));

const CoverMessage = props => {
    const classes = useStyles();

    return (
        <Box className={`${classes.root} coverMessage ${props.className || ''}`}>
            <Box className={`${classes.content} coverMessage__content ${props.innerClassName || ''}`}>
                <div className={classes.typography}>{props.message}</div>
            </Box>
        </Box>
    )
}

CoverMessage.propTypes = {
    message: PropTypes.string,
    className: PropTypes.string,
    innerClassName: PropTypes.string
}

export default CoverMessage
